import type { TenantSettings } from '../api/types';

export interface MoneyFormatter {
  (amount: number | null | undefined): string;
  currency: string;
}

export function moneyFormatter(settings: TenantSettings | null, locale = 'en-US'): MoneyFormatter {
  const code = (settings?.currency?.code ?? 'usd').toUpperCase();
  let nf: Intl.NumberFormat;
  try {
    nf = new Intl.NumberFormat(locale, { style: 'currency', currency: code });
  } catch {
    nf = new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' });
  }
  const fmt = ((amount: number | null | undefined) => (typeof amount === 'number' && Number.isFinite(amount) ? nf.format(amount) : '—')) as MoneyFormatter;
  fmt.currency = code;
  return fmt;
}

export function timeFormatOf(settings: TenantSettings | null): '12' | '24' {
  return settings?.locale?.data?.time_format === '24' ? '24' : '12';
}

/** Stable DOM id for a field key (`user.email` → `cbf-user-email`). */
export function fieldId(key: string): string {
  return 'cbf-' + key.replace(/[^a-zA-Z0-9]+/g, '-').replace(/-+$/, '');
}

export function discountLabel(percent: number | undefined, amount: number | undefined, money: MoneyFormatter): string | null {
  if (percent && percent > 0) return `Save ${percent}%`;
  if (amount && amount > 0) return `Save ${money(amount)}`;
  return null;
}
